import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { compose, withHandlers, withProps } from "recompose";

export const DeleteButtons = ({
  editProps,
  deleteProps,
  url,
  id,
  wrapOnDelete,
  allowDelete,
  readOnly,
}) =>
  readOnly ? (
    <span>
      <Link
        className="btn btn-primary btn-sm mr-1"
        to={`${url}/${id}`}
        {...editProps}
      >
        <span className="fa fa-eye" />
      </Link>
    </span>
  ) : (
    <span>
      {allowDelete && (
        <Link
          size="sm"
          {...deleteProps}
          onClick={wrapOnDelete}
        >
          {/* <span className="fa fa-trash" /> */}
          <i className="fa fa-trash" aria-hidden="true" style={{color:'#E64848', fontSize:'19px', padding:'0px 0px 0px 4px'}}></i>
        </Link>
      )}
    </span>
  );

const enhance = compose(
  withProps(({ onDelete }) => ({
    allowDelete: !!onDelete,
  })),
  withHandlers({
    wrapOnDelete:
      ({ id, onDelete }) =>
      () =>
        onDelete(id),
  })
);

export default enhance(DeleteButtons);
